export default "__VITE_ASSET__Bofv$ibL__"